import { MARKETING_SIGNUP, SALES_SIGNUP } from 'growth-onboarding-signup-redirect/constants/signupConstants';
import { Flow } from 'signup-constants/Flow';
import { Data } from 'signup-constants/signupData/Data';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { isPostVerification } from '../../flow-settings/settingsSelectors';
import { GSWHIndustry, Industry } from '../../signup-data/IndusrtyOption';
import { getExistingUserStep } from '../../step-existing-user/existingUserUtils';
import { getWhichOAuthSelected } from '../../store/app/selectors';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { getIsActiveAndAssignedToVariant, getParameter } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { Tracker } from '../../store/tracking/action-creators';
import { getIsMobile } from '../../utils/deviceUtils';
import { isFlow } from '../../utils/isFlow';
import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../ExperimentKeys';
import { ExperimentParameterGroup } from '../ExperimentParameterGroup';
import { LoadingKey } from '../../app-active-loading/LoadingKey';
export const industryCollectionMethod = industryInput => {
  return industryInput ? 'input' : 'button';
};
export const gswhExistingUserPreVerificationSteps = [Step.LandingPage, Step.CodeVerification];
export const acq142VariantAPostVerificationSteps = [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
export const acq142VariantAPostAccountCreationSteps = [Step.ProductExperience, Step.ProblemAwareness, Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.UseCase, Step.AhaMoment, ...(getIsMobile() ? [Step.MobileAppPrompt] : [])];
export const acq142VariantBPostVerificationSteps = [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.HubletSelection];
export const setupAuthForOAuthExistingUserGSWH = (state, experimentKey, dispatch) => {
  const preVerification = gswhExistingUserPreVerificationSteps;
  let postVerification;
  let postAccountCreation = [];
  const parameter = getParameter(state, experimentKey);
  const oAuthProviderSelected = getWhichOAuthSelected(state);
  dispatch(Tracker.signupInteraction(`${experimentKey}-${oAuthProviderSelected}-oauth-existing-user-${parameter}`));
  if (parameter === ExperimentParameterGroup.Variant_A) {
    postVerification = acq142VariantAPostVerificationSteps;
    postAccountCreation = acq142VariantAPostAccountCreationSteps;
  } else if (parameter === ExperimentParameterGroup.Variant_B) {
    postVerification = acq142VariantBPostVerificationSteps;
  }
  let nextSteps = [...preVerification, ...postVerification, ...postAccountCreation];
  if (getIsAuthenticated(state) && !isPostVerification()) {
    nextSteps = NextStepManager.pushNextSteps(getExistingUserStep())(nextSteps);
  }
  dispatch(setFlow(nextSteps, preVerification, postVerification, postAccountCreation, getFlowSteps().postExistingAccountSelection));
};
export const gswhIndustryToIndustryMapping = {
  [GSWHIndustry.TechnologyAndServices]: Industry.TechnologyAndServices,
  [GSWHIndustry.Education]: Industry.Education,
  [GSWHIndustry.Consulting]: Industry.Consulting
};
export const isInACQ142VariantACRM = state => {
  const isInVariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_A]);
  return isInVariantA && isFlow(Flow.Crm);
};
export const isInACQ142VariantAMSS = state => {
  const isInVariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_A]);
  return isInVariantA && !isFlow(Flow.Crm);
};
export const isInACQ142VariantBCRM = state => {
  const isInVariantB = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_B]);
  return isInVariantB && isFlow(Flow.Crm);
};
export const isInACQ142VariantMS = state => {
  const isInVariantMS = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]);
  return isInVariantMS && isFlow([Flow.Marketing, Flow.Sales]);
};
const HubInterestToSignupType = new Map([[HubInterestOption.Marketing, MARKETING_SIGNUP], [HubInterestOption.Sales, SALES_SIGNUP]]);
export const getACQ142SignupType = state => {
  return HubInterestToSignupType.get(getSignupDataValue(state, Data.HubInterest));
};
export const getACQ142EndpointLoadingKey = (state, loadingKey) => {
  const parameter = getParameter(state, ExperimentKeys.ACQ0142);
  const isACQ142VariantAMSS = isInACQ142VariantAMSS(state);
  if (loadingKey === LoadingKey.SignupRequest) {
    return parameter === ExperimentParameterGroup.Variant_B ? LoadingKey.ACQ142VariantBSignupRequest : LoadingKey.ACQ142SignupRequest;
  } else if (loadingKey === LoadingKey.LoginAfterSignup) {
    return isACQ142VariantAMSS ? LoadingKey.ACQ142LoginAfterSignupMS : LoadingKey.ACQ142LoginAfterSignup;
  }
  return loadingKey;
};